import { useFeatureFlag, User } from "configcat-react"

export const useFlagProtection = (
  key: string,
  userIdentityId?: string | null
) => {
  const userObject = userIdentityId ? new User(userIdentityId) : undefined
  const { value } = useFeatureFlag(key, null, userObject)
  return value
}
